import React from 'react'
import {Country,State} from 'country-state-city'
import { useState } from 'react'
const Shipping = () => {
  const [country, setCountry] = useState("")
  const [state, setState] = useState("")
  console.log(state)
  return <section className='shipping'>
    <main className='shippingmain'>
        <h1>Shipping Details</h1>
        <form>
          <div>
            <label>H.No.</label>
            <input type="text" placeholder='Enter House No.' />
          </div>
          <div>
            <label>City</label>
            <input type="text" placeholder='Enter City' />
          </div>
          <div>
            <label>Country</label>
            <select onChange={(e)=>setCountry(e.target.value)}>
              <option value="">Country</option>
              {
                Country && Country.getAllCountries().map(country=>(
                  <option key={country.isoCode} value={country.isoCode}>{country.name}</option>
                ))
              }
            </select>
          </div>
          <div>
            <label>State</label>
            <select onChange={(e)=>setState(e.target.value)}>
              <option value="">State</option>
              {
                State && State.getStatesOfCountry(country).map(state=>(
                  <option key={country.isoCode} value={state.isoCode}>{state.name}</option>
                ))
              }
            </select>
          </div>
          <div>
            <label>Pin Code</label>
            <input type="number" placeholder='Enter Pincode' />
          </div>
          <div>
            <label>Phone No.</label>
            <input type="number" placeholder='Enter Phone No.' />
          </div>
          <button type="submit">Confirm Order</button>
        </form>
    </main>
  </section>
}

export default Shipping